import { useState, useEffect } from 'react';
import { Save, Trash2, Plus,  Loader } from 'lucide-react';
import { FaRobot } from 'react-icons/fa';

export default function MotiveIntegrationForm({ fetchMotiveConfigs,
  handleConfigChange,
  handleRemoveConfig,
  handleSaveConfig,
  validationErrors,
  savingStates,
  motiveConfigs,
  setMotiveConfigs,motiveLoading, createEmptyConfig
   }) {




  useEffect(() => {
    fetchMotiveConfigs();
  }, []);


  const handleAddConfig = () => {
    setMotiveConfigs([...motiveConfigs, createEmptyConfig()]);
  };


  const getFieldError = (index, field) => {
    return validationErrors[`${index}-${field}`];
  };

  const getSaveButtonText = index => {
    if (savingStates[index]) {
      return 'Saving...';
    }
    return motiveConfigs[index]._id ? 'Update Configuration' : 'Save Configuration';
  };

  const isSaveButtonDisabled = index => {
    return savingStates[index];
  };

  if (motiveLoading) {
    return (
      <div className="text-center py-5">
        <Loader className="animate-spin mx-auto mb-3" size={40} />
        <p className="text-muted">Loading configurations...</p>
      </div>
    );
  }

  return (
    <>
      <style>{`
        .motive-card {
          border: none;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          margin-bottom: 2rem;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .motive-card:hover {
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
        }

        .motive-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 1.5rem;
          color: white;
        }

        .config-card {
          background: white;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          padding: 1.5rem;
          margin-bottom: 1.5rem;
          transition: all 0.3s ease;
        }

        .config-card:hover {
          border-color: #667eea;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
        }

        .btn-action {
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          font-size: 14px;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          cursor: pointer;
        }

        .btn-save {
          background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
          color: white;
        }

        .btn-save:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(72, 187, 120, 0.4);
        }

        .btn-save:disabled {
          background: #9ca3af;
          cursor: not-allowed;
        }

        .btn-test {
          background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
          color: white;
        }

        .btn-test:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(66, 153, 225, 0.4);
        }

        .btn-test:disabled {
          background: #9ca3af;
          cursor: not-allowed;
        }

        .btn-delete {
          background: #fff;
          border: 2px solid #fee2e2;
          color: #ef4444;
        }

        .btn-delete:hover {
          background: #ef4444;
          color: white;
          border-color: #ef4444;
        }

        .btn-add {
          background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
          color: white;
        }

        .btn-add:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
        }

        .action-buttons {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 2px solid #e9ecef;
        }

        .error-message {
          color: #dc3545;
          font-size: 12px;
          margin-top: 4px;
          display: block;
        }

        .is-invalid {
          border-color: #dc3545 !important;
        }

        .readonly-field {
          background-color: #f8f9fa;
          color: #6c757d;
          cursor: not-allowed;
        }

        .test-section {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 1rem;
          margin-top: 1rem;
        }

        .test-result {
          margin-top: 1rem;
          padding: 1rem;
          border-radius: 8px;
          background: white;
          border: 1px solid #e9ecef;
        }

        .test-success {
          border-left: 4px solid #28a745;
        }

        .test-error {
          border-left: 4px solid #dc3545;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .animate-spin {
          animation: spin 1s linear infinite;
        }

        .section-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 8px 18px;
          border-radius: 25px;
          font-size: 15px;
          font-weight: 600;
          color: white;
          margin-bottom: 20px;
        }
        
        .count-badge {
          background: white;
          color: #333;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
          margin-left: 4px;
        }
      `}</style>

      <div className="motive-card">
        <div className="motive-header" style={{ background: '#142127' }}>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <h3 className="mb-1 fw-bold text-white"><FaRobot /> Motive Integration Manager</h3>
              <p className="mb-0 text-white-50">Configure and manage your Motive AI integrations</p>
            </div>

            <div className="section-badge" style={{ backgroundColor: '#6366f1' }}>
              {motiveConfigs.length} Configuration
              {motiveConfigs.length !== 1 ? 's' : ''}
            </div>
          </div>
        </div>

        <div className="p-4 bg-light">
          {motiveConfigs.map((config, index) => (
            <div key={index} className="config-card">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <h5 className="mb-0 text-primary">
                  Configuration {index + 1}
                  {config._id && <span className="badge bg-success ms-2">Saved</span>}
                </h5>
                <button
                  type="button"
                  onClick={() => handleRemoveConfig(index)}
                  className="btn-action btn-delete"
                >
                  <Trash2 size={16} />
                  Remove
                </button>
              </div>

              <div className="row g-3">
                {/* Row 1: Name, Organization, Space */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Configuration Name *
                  </label>
                  <input
                    type="text"
                    className={`form-control border-2 ${getFieldError(index, 'motive_name') ? 'is-invalid' : ''}`}
                    value={config.motive_name || ''}
                    onChange={e => handleConfigChange(index, 'motive_name', e.target.value)}
                    placeholder="Enter configuration name"
                  />
                  {getFieldError(index, 'motive_name') && (
                    <span className="error-message">{getFieldError(index, 'motive_name')}</span>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Organization *
                  </label>
                  <input
                    type="text"
                    className={`form-control border-2 ${getFieldError(index, 'motive_organization') ? 'is-invalid' : ''}`}
                    value={config.motive_organization || ''}
                    onChange={e => handleConfigChange(index, 'motive_organization', e.target.value)}
                    placeholder="e.g: organization.******"
                  />
                  {getFieldError(index, 'motive_organization') && (
                    <span className="error-message">
                      {getFieldError(index, 'motive_organization')}
                    </span>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Space *
                  </label>
                  <input
                    type="text"
                    className={`form-control border-2 ${getFieldError(index, 'motive_space') ? 'is-invalid' : ''}`}
                    value={config.motive_space || ''}
                    onChange={e => handleConfigChange(index, 'motive_space', e.target.value)}
                    placeholder="e.g: space.******"
                  />
                  {getFieldError(index, 'motive_space') && (
                    <span className="error-message">{getFieldError(index, 'motive_space')}</span>
                  )}
                </div>

                {/* Row 2: Agent, Deployment, Client ID */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Agent ID *
                  </label>
                  <input
                    type="text"
                    className={`form-control border-2 ${getFieldError(index, 'motive_agent') ? 'is-invalid' : ''}`}
                    value={config.motive_agent || ''}
                    onChange={e => handleConfigChange(index, 'motive_agent', e.target.value)}
                    placeholder="e.g: agent.******"
                  />
                  {getFieldError(index, 'motive_agent') && (
                    <span className="error-message">{getFieldError(index, 'motive_agent')}</span>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Deployment *
                  </label>
                  <input
                    type="text"
                    className="form-control border-2"
                    value={config.motive_deployment || ''}
                    onChange={e => handleConfigChange(index, 'motive_deployment', e.target.value)}
                    placeholder="e.g: deployment.******"
                  />
                  {getFieldError(index, 'motive_deployment') && (
                    <span className="error-message">
                      {getFieldError(index, 'motive_deployment')}
                    </span>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Client ID *
                  </label>
                  <input
                    type="text"
                    className={`form-control border-2 ${getFieldError(index, 'motive_client_id') ? 'is-invalid' : ''}`}
                    value={config.motive_client_id || ''}
                    onChange={e => handleConfigChange(index, 'motive_client_id', e.target.value)}
                    placeholder="Enter client ID"
                  />
                  {getFieldError(index, 'motive_client_id') && (
                    <span className="error-message">
                      {getFieldError(index, 'motive_client_id')}
                    </span>
                  )}
                </div>

                {/* Row 3: Function, Base URL, Client Secret */}
                <div className="col-md-4" style={{display: 'none'}}>
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Function *
                  </label>
                  <input
                    type="text"
                    // className={`form-control border-2 ${getFieldError(index, 'motive_function') ? 'is-invalid' : ''}`}
                    // value={config.motive_function || ''}
                    // onChange={e => handleConfigChange(index, 'motive_function', e.target.value)}
                    placeholder="Enter function"
                  />
                  {/* {getFieldError(index, 'motive_function') && (
                    <span className="error-message">{getFieldError(index, 'motive_function')}</span>
                  )} */}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Base URL *
                  </label>
                  <input
                    type="url"
                    className={`form-control border-2 ${getFieldError(index, 'motive_baseurl') ? 'is-invalid' : ''}`}
                    value={config.motive_baseurl || ''}
                    onChange={e => handleConfigChange(index, 'motive_baseurl', e.target.value)}
                    placeholder="https://example.dev"
                  />
                  {getFieldError(index, 'motive_baseurl') && (
                    <span className="error-message">{getFieldError(index, 'motive_baseurl')}</span>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Client Secret *
                  </label>
                  <input
                    type="password"
                    className={`form-control border-2 ${getFieldError(index, 'motive_client_secret') ? 'is-invalid' : ''}`}
                    value={config.motive_client_secret || ''}
                    onChange={e =>
                      handleConfigChange(index, 'motive_client_secret', e.target.value)
                    }
                    placeholder="Enter client secret"
                  />
                  {getFieldError(index, 'motive_client_secret') && (
                    <span className="error-message">
                      {getFieldError(index, 'motive_client_secret')}
                    </span>
                  )}
                </div>

                {/* Row 4: Knowledge, Temperature, Output Text */}
                <div className="col-md-4" style={{display: 'none'}}>
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Knowledge Repository ID
                  </label>
                  <input
                    type="text"
                    className="form-control border-2"
                    value={config.motive_knowledge || ''}
                    onChange={e => handleConfigChange(index, 'motive_knowledge', e.target.value)}
                    placeholder="Enter knowledge repository ID"
                  />
                </div>

                <div className="col-md-4" style={{display: 'none'}}>
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Temperature
                  </label>
                  <input
                    type="number"
                    className="form-control border-2 readonly-field"
                    value={2}
                    readOnly
                    disabled
                  />
                </div>

                <div className="col-md-4" style={{display: 'none'}}>
                  <label className="form-label fw-semibold small text-uppercase text-muted mb-2">
                    Not Found Response Text
                  </label>
                  <input
                    type="text"
                    className="form-control border-2 readonly-field"
                    value="I have not found this text"
                    readOnly
                    disabled
                  />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="action-buttons">
                <button
                  type="button"
                  className="btn-action btn-save"
                  style={{ background: '#142127' }}
                  onClick={() => handleSaveConfig(index)}
                  disabled={isSaveButtonDisabled(index)}
                >
                  {savingStates[index] ? (
                    <>
                      <Loader size={16} className="animate-spin" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <Save size={16} />
                      {getSaveButtonText(index)}
                    </>
                  )}
                </button>
              </div>
            </div>
          ))}

          <div className="text-center mt-4">
            <button
              type="button"
              className="btn-action btn-add"
              onClick={handleAddConfig}
              style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
            >
              <Plus size={18} />
              Add New Configuration
            </button>
          </div>
        </div>
      </div>
    </>
  );
}


